import { FC } from 'react';

import { EllipsesWrapper } from './Message.styled';

export const LoadingEllipsis: FC = () => {
  return (
    <EllipsesWrapper>
      <span title={'ellipses'} />
      <span title={'ellipses'} />
      <span title={'ellipses'} />
    </EllipsesWrapper>
  );
};
